import fluencyTimeline from "./fluency/timeline";
import {
  initConfigFluency,
  initStoreFluency,
  fetchAndParseCorpusFluency,
} from "./fluency/helpers";
import assetsFluency from "./fluency/assets.json";

import alpacaTimeline from "./alpaca/timeline";
import {
  initConfigAlpaca,
  initStoreAlpaca,
  fetchAndParseCorpusAlpaca,
} from "./alpaca/helpers";
import assetsAlpaca from "./alpaca/assets.json";

export default {
  fluencyArf: {
    initConfig: initConfigFluency,
    initStore: initStoreFluency,
    loadCorpus: fetchAndParseCorpusFluency,
    buildTaskTimeline: fluencyTimeline,
    bucketURI: "https://storage.googleapis.com/roam-fluency",
    assets: assetsFluency,
    variants: {},
  },

  fluencyCalf: {
    initConfig: initConfigFluency,
    initStore: initStoreFluency,
    loadCorpus: fetchAndParseCorpusFluency,
    buildTaskTimeline: fluencyTimeline,
    bucketURI: "https://storage.googleapis.com/roam-fluency",
    assets: assetsFluency,
    variants: {},
  },

  roamAlpaca: {
    initConfig: initConfigAlpaca,
    initStore: initStoreAlpaca,
    loadCorpus: fetchAndParseCorpusAlpaca,
    buildTaskTimeline: alpacaTimeline,
    bucketURI: "https://storage.googleapis.com/roam-fluency",
    assets: assetsAlpaca,
    variants: {},
  },
};
